export default function ProfileGdprModal({
  gdprChecked, setGdprChecked,
  gdprText, setGdprText,
  gdprLoading,
  onClose,
  onConfirm,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-lg rounded-3xl bg-white border border-slate-200 shadow-xl overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-200 flex items-start justify-between gap-3">
          <div>
            <h4 className="text-sm font-semibold text-slate-900">
              RGPD — demande de suppression des données
            </h4>
            <p className="text-xs text-slate-500 mt-1">
              Action sensible : merci de confirmer avant envoi.
            </p>
          </div>
          <button type="button" onClick={onClose} disabled={gdprLoading}
            className="text-xs px-2 py-1 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-700 transition">
            Fermer ✕
          </button>
        </div>

        <div className="px-6 py-5 space-y-4">
          <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4">
            <p className="text-xs text-amber-900 font-semibold">Ce que fait cette demande</p>
            <ul className="mt-2 text-xs text-amber-900/80 list-disc pl-5 space-y-1">
              <li>Envoie une demande de suppression liée à votre compte entreprise.</li>
              <li>Nous traitons la demande manuellement (conformité RGPD).</li>
              <li>Cette action peut impacter l'accès à l'historique et aux données associées.</li>
            </ul>
          </div>

          <label className="flex items-start gap-3 text-sm text-slate-700">
            <input type="checkbox" checked={gdprChecked}
              onChange={(e) => setGdprChecked(e.target.checked)}
              className="mt-1 h-4 w-4 rounded border-slate-300" />
            <span>Je confirme vouloir envoyer une <span className="font-semibold">demande de suppression</span>.</span>
          </label>

          <div>
            <label className="text-xs font-medium text-slate-600">
              Pour confirmer, tapez <span className="font-semibold text-slate-900">SUPPRIMER</span>
            </label>
            <input value={gdprText} onChange={(e) => setGdprText(e.target.value)}
              placeholder="SUPPRIMER"
              className="mt-1 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300" />
          </div>
        </div>

        <div className="px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-2">
          <button type="button" onClick={onClose} disabled={gdprLoading}
            className="px-4 py-2 rounded-full text-sm bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 shadow-sm">
            Annuler
          </button>
          <button type="button" onClick={onConfirm}
            disabled={gdprLoading || !gdprChecked || gdprText.trim().toUpperCase() !== "SUPPRIMER"}
            className="px-4 py-2 rounded-full text-sm font-medium bg-red-600 text-white hover:bg-red-500 disabled:opacity-40 disabled:cursor-not-allowed shadow-sm">
            {gdprLoading ? "Envoi..." : "Envoyer la demande"}
          </button>
        </div>
      </div>
    </div>
  );
}